import React, { useEffect, useState } from "react";
import "./main_sidebar.css";
import Accordion from "react-bootstrap/Accordion";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { IDS } from "../../utils/IDS";
import { Allpermissions, isTokenValid } from "../../features/auth/Slice";

const Sidebar = ({ closeSidebar }) => {
  // Get the current location
  const dispatch = useDispatch();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  console.log("location", location.pathname);
  const Permission = useSelector((state) => state.auth?.admin_info);

  useEffect(() => {
    dispatch(Allpermissions());
  }, [dispatch]);

  const getActiveAccordionKey = () => {
    const path = location.pathname;

    const dashboardPaths = ["/"];

    const masterPaths = [
      "/country-table",
      "/state-table",
      "/city-table",
      "/pincode-table",
      "/vehicle-type",
      "/vehicle-category",
      "/vehicle",
      "/ecofriendly",
      "/banner",
      "/save_location",
      "/good_type",
      "/faq",
      "/trainingvideos",
      "/driverbanner",
      "/recharge-table",
      "/user-recharge-table",
      "/gift-table",
      "/user-gift-table",
    ];

    const aboutPaths = ["/aboutus", "/keyfeature", "/whychooseus"];

    const contentPaths = [
      "/privacypolicy",
      "/driverprivacypolicy",
      "/cutomer-booking-tnc",
      "/customer-terms-and-condition",
      "/driver-terms-and-condition",
    ];

    const customizationPaths = ["/appsetup"];

    const formPaths = ["/contactus", "/enquiry"];

    const customerMgmtPaths = ["/customer", "/driver"];

    const documentPaths = ["/document-require"];
    const notificationPaths = ["/broadcast-send"];
    const couponPaths = ["/coupon", "/coupon-history"];
    const userMgmtPaths = ["/users", "/roles"];
    const rechargeMgmtPaths = ["/recharge-table", "/user-recharge-table"];
    const giftMgmtPaths = ["/gift-table", "/user-gift-table"];
    const cabBookingPaths = ["/cab-booking"];
    const bookingPaths = ["/booking"];
    const shareBookingPaths = ["/share-booking"];

    const walletPaths = [
      "/withdraw-request",
      "/wallet-history",
      "/wallet-fund-add-request",
    ];

    if (dashboardPaths.includes(path)) return "1";
    if (masterPaths.includes(path)) return "11";
    if (aboutPaths.includes(path)) return "7";
    if (contentPaths.includes(path)) return "9";
    if (customizationPaths.includes(path)) return "10";
    if (formPaths.includes(path)) return "12";
    if (customerMgmtPaths.includes(path)) return "13";
    if (bookingPaths.includes(path)) return "14";
    if (walletPaths.includes(path)) return "15";
    if (documentPaths.includes(path)) return "21";
    if (notificationPaths.includes(path)) return "20";
    if (couponPaths.includes(path)) return "22";
    if (userMgmtPaths.includes(path)) return "23";
    if (rechargeMgmtPaths.includes(path)) return "25";
    if (giftMgmtPaths.includes(path)) return "26";
    if (cabBookingPaths.includes(path)) return "18";
    if (shareBookingPaths.includes(path)) return "24";
  };

  return (
    <>
      <section className="sidebar_main theme_bg">
        {/* <div className="logo_sec">
          <h3 className="hometitle">
            <Link to="/">
              <FontAwesomeIcon icon={faHouse} /> Home
            </Link>
          </h3>
        </div> */}

        <div className="sidebar_list">
          <Accordion defaultActiveKey={getActiveAccordionKey()} flush>
            <Accordion.Item eventKey="1">
              <Link to="/" onClick={closeSidebar}>
                <Accordion.Header
                  className={` ${isActive("/") ? "active" : ""}`}
                >
                  Dashboard
                </Accordion.Header>
              </Link>
            </Accordion.Item>
            {Permission?.includes(IDS.Permission.Country.List) ||
            Permission?.includes(IDS.Permission.State.List) ||
            Permission?.includes(IDS.Permission.City.List) ||
            Permission?.includes(IDS.Permission.Pincode.List) ||
            Permission?.includes(IDS.Permission.Banner.List) ||
            Permission?.includes(IDS.Permission.Save_Location.List) ||
            Permission?.includes(IDS.Permission.Good_Type.List) ||
            Permission?.includes(IDS.Permission.Faq.List) ||
            Permission?.includes(IDS.Permission.Training_Video.List) ||
            Permission?.includes(IDS.Permission.Driver_Banner.List) ||
            Permission?.includes(IDS.Permission.Vehicle_Type.List) ? (
              <Accordion.Item eventKey="11">
                <Accordion.Header>Master</Accordion.Header>
                <Accordion.Body>
                  <div className="acc_inner_menu">
                    {Permission?.includes(IDS.Permission.Country.List) ||
                    Permission?.includes(IDS.Permission.Country.Add) ||
                    Permission?.includes(IDS.Permission.Country.Edit) ||
                    Permission?.includes(IDS.Permission.Country.Delete) ? (
                      <Link to="/country-table" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/country-table") ? "active" : ""
                          }`}
                        >
                          Country
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.State.List) ||
                    Permission?.includes(IDS.Permission.State.Add) ||
                    Permission?.includes(IDS.Permission.State.Edit) ||
                    Permission?.includes(IDS.Permission.State.Delete) ? (
                      <Link to="/state-table" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/state-table") ? "active" : ""
                          }`}
                        >
                          State
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.City.List) ||
                    Permission?.includes(IDS.Permission.City.Add) ||
                    Permission?.includes(IDS.Permission.City.Edit) ||
                    Permission?.includes(IDS.Permission.City.Delete) ? (
                      <Link to="/city-table" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/city-table") ? "active" : ""
                          }`}
                        >
                          District
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Pincode.List) ||
                    Permission?.includes(IDS.Permission.Pincode.Add) ||
                    Permission?.includes(IDS.Permission.Pincode.Edit) ||
                    Permission?.includes(IDS.Permission.Pincode.Delete) ? (
                      <Link to="/pincode-table" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/pincode-table") ? "active" : ""
                          }`}
                        >
                          Pincode
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Vehicle_Type.List) ||
                    Permission?.includes(IDS.Permission.Vehicle_Type.Add) ||
                    Permission?.includes(IDS.Permission.Vehicle_Type.Edit) ||
                    Permission?.includes(IDS.Permission.Vehicle_Type.Delete) ? (
                      <Link to="/vehicle-type" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/vehicle-type") ? "active" : ""
                          }`}
                        >
                          Vehicle Type
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(
                      IDS.Permission.Vehicle_Category.List,
                    ) ||
                    Permission?.includes(IDS.Permission.Vehicle_Category.Add) ||
                    Permission?.includes(
                      IDS.Permission.Vehicle_Category.Edit,
                    ) ||
                    Permission?.includes(
                      IDS.Permission.Vehicle_Category.Delete,
                    ) ? (
                      <Link to="/vehicle-category" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/vehicle-category") ? "active" : ""
                          }`}
                        >
                          Vehicle Category
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(
                      IDS.Permission.Vehicle_Category.List,
                    ) ||
                    Permission?.includes(IDS.Permission.Vehicle_Category.Add) ||
                    Permission?.includes(
                      IDS.Permission.Vehicle_Category.Edit,
                    ) ||
                    Permission?.includes(
                      IDS.Permission.Vehicle_Category.Delete,
                    ) ? (
                      <Link to="/vehicle" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/vehicle") ? "active" : ""
                          }`}
                        >
                          Vehicle
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Eco_Friendly.List) ||
                    Permission?.includes(IDS.Permission.Eco_Friendly.Add) ||
                    Permission?.includes(IDS.Permission.Eco_Friendly.Edit) ||
                    Permission?.includes(IDS.Permission.Eco_Friendly.Delete) ? (
                      <Link to="/ecofriendly" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/ecofriendly") ? "active" : ""
                          }`}
                        >
                          Eco Friendly
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Banner.List) ||
                    Permission?.includes(IDS.Permission.Banner.Add) ||
                    Permission?.includes(IDS.Permission.Banner.Edit) ||
                    Permission?.includes(IDS.Permission.Banner.Delete) ? (
                      <Link to="/banner" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/banner") ? "active" : ""
                          }`}
                        >
                          Customer Banner
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {/* {Permission?.includes(IDS.Permission.Save_Location.List) ||
                    Permission?.includes(IDS.Permission.Save_Location.Add) ||
                    Permission?.includes(IDS.Permission.Save_Location.Edit) ||
                    Permission?.includes(
                      IDS.Permission.Save_Location.Delete
                    ) ? (
                      <Link to="/save_location" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/save_location") ? "active" : ""
                          }`}
                        >
                          Save Location
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )} */}

                    {Permission?.includes(IDS.Permission.Good_Type.List) ||
                    Permission?.includes(IDS.Permission.Good_Type.Add) ||
                    Permission?.includes(IDS.Permission.Good_Type.Edit) ||
                    Permission?.includes(IDS.Permission.Good_Type.Delete) ? (
                      <Link to="/good_type" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/good_type") ? "active" : ""
                          }`}
                        >
                          Good Type
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Faq.List) ||
                    Permission?.includes(IDS.Permission.Faq.Add) ||
                    Permission?.includes(IDS.Permission.Faq.Edit) ||
                    Permission?.includes(IDS.Permission.Faq.Delete) ? (
                      <Link to="/faq" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/faq") ? "active" : ""
                          }`}
                        >
                          FAQ
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Training_Video.List) ||
                    Permission?.includes(IDS.Permission.Training_Video.Add) ||
                    Permission?.includes(IDS.Permission.Training_Video.Edit) ||
                    Permission?.includes(
                      IDS.Permission.Training_Video.Delete,
                    ) ? (
                      <Link to="/trainingvideos" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/trainingvideos") ? "active" : ""
                          }`}
                        >
                          Training Video
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Driver_Banner.List) ||
                    Permission?.includes(IDS.Permission.Driver_Banner.Add) ||
                    Permission?.includes(IDS.Permission.Driver_Banner.Edit) ||
                    Permission?.includes(
                      IDS.Permission.Driver_Banner.Delete,
                    ) ? (
                      <Link to="/driverbanner" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/driverbanner") ? "active" : ""
                          }`}
                        >
                          Driver Banner
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Driver_Banner.List) ||
                    Permission?.includes(IDS.Permission.Driver_Banner.Add) ||
                    Permission?.includes(IDS.Permission.Driver_Banner.Edit) ||
                    Permission?.includes(
                      IDS.Permission.Driver_Banner.Delete,
                    ) ? (
                      <Link to="/booking-cancel-reason" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/booking-cancel-reason") ? "active" : ""
                          }`}
                        >
                          Booking Cancel Reason
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Driver_Banner.List) ||
                    Permission?.includes(IDS.Permission.Driver_Banner.Add) ||
                    Permission?.includes(IDS.Permission.Driver_Banner.Edit) ||
                    Permission?.includes(
                      IDS.Permission.Driver_Banner.Delete,
                    ) ? (
                      <Link to="/amenity" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/amenity") ? "active" : ""
                          }`}
                        >
                          Amenity
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Driver_Banner.List) ||
                    Permission?.includes(IDS.Permission.Driver_Banner.Add) ||
                    Permission?.includes(IDS.Permission.Driver_Banner.Edit) ||
                    Permission?.includes(
                      IDS.Permission.Driver_Banner.Delete,
                    ) ? (
                      <Link to="/about-me" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/about-me") ? "active" : ""
                          }`}
                        >
                          About Me
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              <></>
            )}
            {Permission?.includes(IDS.Permission.Recharge.List) ? (
              <Accordion.Item eventKey="25">
                <Accordion.Header>Recharge Management</Accordion.Header>
                <Accordion.Body>
                  <div className="acc_inner_menu">
                    {Permission?.includes(IDS.Permission.Recharge.List) ||
                    Permission?.includes(IDS.Permission.Recharge.Add) ||
                    Permission?.includes(IDS.Permission.Recharge.Edit) ||
                    Permission?.includes(IDS.Permission.Recharge.Delete) ? (
                      <>
                        <Link to="/recharge-table" onClick={closeSidebar}>
                          <div
                            className={`menu_div ${
                              isActive("/recharge-table") ? "active" : ""
                            }`}
                          >
                            Recharge
                          </div>
                        </Link>

                        <Link to="/user-recharge-table" onClick={closeSidebar}>
                          <div
                            className={`menu_div ${
                              isActive("/user-recharge-table") ? "active" : ""
                            }`}
                          >
                            Recharge History
                          </div>
                        </Link>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              <></>
            )}
            {Permission?.includes(IDS.Permission.Gift.List) ? (
              <Accordion.Item eventKey="26">
                <Accordion.Header>Gift Management</Accordion.Header>
                <Accordion.Body>
                  <div className="acc_inner_menu">
                    {Permission?.includes(IDS.Permission.Gift.List) ||
                    Permission?.includes(IDS.Permission.Gift.Add) ||
                    Permission?.includes(IDS.Permission.Gift.Edit) ||
                    Permission?.includes(IDS.Permission.Gift.Delete) ? (
                      <>
                        <Link to="/gift-table" onClick={closeSidebar}>
                          <div
                            className={`menu_div ${
                              isActive("/gift-table") ? "active" : ""
                            }`}
                          >
                            Gift
                          </div>
                        </Link>

                        <Link to="/user-gift-table" onClick={closeSidebar}>
                          <div
                            className={`menu_div ${
                              isActive("/user-gift-table") ? "active" : ""
                            }`}
                          >
                            Gift History
                          </div>
                        </Link>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              <></>
            )}
            {Permission?.includes(IDS.Permission.Coupon.List) ? (
              <Accordion.Item eventKey="22">
                <Accordion.Header>Coupons Management</Accordion.Header>
                <Accordion.Body>
                  <div className="acc_inner_menu">
                    <Link to="/coupon" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/coupon") ? "active" : ""
                        }`}
                      >
                        Coupons
                      </div>
                    </Link>
                    <Link to="/coupon-history" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/coupon-history") ? "active" : ""
                        }`}
                      >
                        Coupons History
                      </div>
                    </Link>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              <></>
            )}
            {Permission?.includes(IDS.Permission.Broadcast.List) ? (
              <Accordion.Item eventKey="20">
                <Accordion.Header>Broadcast Notifications</Accordion.Header>
                <Accordion.Body>
                  <div className="acc_inner_menu">
                    <Link to="/broadcast-send" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/broadcast-send") ? "active" : ""
                        }`}
                      >
                        Broadcast
                      </div>
                    </Link>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              <></>
            )}
            {Permission?.includes(IDS.Permission.Recharge.List) ? (
              <Accordion.Item eventKey="21">
                <Link to="/document-require" onClick={closeSidebar}>
                  <Accordion.Header>Document Requirements</Accordion.Header>
                </Link>
              </Accordion.Item>
            ) : (
              <></>
            )}
            {Permission?.includes(IDS.Permission.About_Us.List) ? (
              <Accordion.Item eventKey="7">
                <Accordion.Header>About</Accordion.Header>
                <Accordion.Body>
                  <div className="acc_inner_menu">
                    {Permission?.includes(IDS.Permission.About_Us.List) ||
                    Permission?.includes(IDS.Permission.About_Us.Add) ||
                    Permission?.includes(IDS.Permission.About_Us.Edit) ||
                    Permission?.includes(IDS.Permission.About_Us.Delete) ? (
                      <Link to="/aboutus" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/aboutus") ? "active" : ""
                          }`}
                        >
                          About Us
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              <></>
            )}
            {Permission?.includes(IDS.Permission.Term_Condition.List) ||
            Permission?.includes(IDS.Permission.Privacy_Policy.List) ||
            Permission?.includes(IDS.Permission.Term_Condition.List) ? (
              <Accordion.Item eventKey="9">
                <Accordion.Header>Content</Accordion.Header>
                <Accordion.Body>
                  <div className="acc_inner_menu">
                    {Permission?.includes(IDS.Permission.Term_Condition.List) ||
                    Permission?.includes(IDS.Permission.Term_Condition.Add) ||
                    Permission?.includes(IDS.Permission.Term_Condition.Edit) ||
                    Permission?.includes(
                      IDS.Permission.Term_Condition.Delete,
                    ) ? (
                      <Link to="/termconditions">
                        <div
                          className={`menu_div ${
                            isActive("/termconditions") ? "active" : ""
                          }`}
                        >
                          Customer Terms Conditions
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}
                    {Permission?.includes(IDS.Permission.Privacy_Policy.List) ||
                    Permission?.includes(IDS.Permission.Privacy_Policy.Add) ||
                    Permission?.includes(IDS.Permission.Privacy_Policy.Edit) ||
                    Permission?.includes(
                      IDS.Permission.Privacy_Policy.Delete,
                    ) ? (
                      <Link to="/privacypolicy" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/privacypolicy") ? "active" : ""
                          }`}
                        >
                          Customer Privacy Policy
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Privacy_Policy.List) ||
                    Permission?.includes(IDS.Permission.Privacy_Policy.Add) ||
                    Permission?.includes(IDS.Permission.Privacy_Policy.Edit) ||
                    Permission?.includes(
                      IDS.Permission.Privacy_Policy.Delete,
                    ) ? (
                      <Link to="/driverprivacypolicy" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/driverprivacypolicy") ? "active" : ""
                          }`}
                        >
                          Driver Privacy Policy
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Term_Condition.List) ||
                    Permission?.includes(IDS.Permission.Term_Condition.Add) ||
                    Permission?.includes(IDS.Permission.Term_Condition.Edit) ||
                    Permission?.includes(
                      IDS.Permission.Term_Condition.Delete,
                    ) ? (
                      <Link to="/cutomer-booking-tnc" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/cutomer-booking-tnc") ? "active" : ""
                          }`}
                        >
                          Booking Terms and Conditions
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Term_Condition.List) ||
                    Permission?.includes(IDS.Permission.Term_Condition.Add) ||
                    Permission?.includes(IDS.Permission.Term_Condition.Edit) ||
                    Permission?.includes(
                      IDS.Permission.Term_Condition.Delete,
                    ) ? (
                      <Link
                        to="/driver-terms-and-condition"
                        onClick={closeSidebar}
                      >
                        <div
                          className={`menu_div ${
                            isActive("/driver-terms-and-condition")
                              ? "active"
                              : ""
                          }`}
                        >
                          Driver Terms and Conditions
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Term_Condition.List) ||
                    Permission?.includes(IDS.Permission.Term_Condition.Add) ||
                    Permission?.includes(IDS.Permission.Term_Condition.Edit) ||
                    Permission?.includes(
                      IDS.Permission.Term_Condition.Delete,
                    ) ? (
                      <Link to="/shippingridepolicy">
                        <div
                          className={`menu_div ${
                            isActive("/shippingridepolicy") ? "active" : ""
                          }`}
                        >
                          Shipping And Ride Policy
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Term_Condition.List) ||
                    Permission?.includes(IDS.Permission.Term_Condition.Add) ||
                    Permission?.includes(IDS.Permission.Term_Condition.Edit) ||
                    Permission?.includes(
                      IDS.Permission.Term_Condition.Delete,
                    ) ? (
                      <Link to="/cancellationpolicy">
                        <div
                          className={`menu_div ${
                            isActive("/cancellationpolicy") ? "active" : ""
                          }`}
                        >
                          Cancellation Policy
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Term_Condition.List) ||
                    Permission?.includes(IDS.Permission.Term_Condition.Add) ||
                    Permission?.includes(IDS.Permission.Term_Condition.Edit) ||
                    Permission?.includes(
                      IDS.Permission.Term_Condition.Delete,
                    ) ? (
                      <Link to="/refundpolicy">
                        <div
                          className={`menu_div ${
                            isActive("/refundpolicy") ? "active" : ""
                          }`}
                        >
                          Refund Policy
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              <></>
            )}
            {Permission?.includes(IDS.Permission.App_Setup.List) ? (
              <Accordion.Item eventKey="10">
                <Accordion.Header>Customizaton</Accordion.Header>
                <Accordion.Body>
                  <div className="acc_inner_menu">
                    {Permission?.includes(IDS.Permission.App_Setup.List) ||
                    Permission?.includes(IDS.Permission.App_Setup.Edit) ? (
                      <Link to="/appsetup" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/appsetup") ? "active" : ""
                          }`}
                        >
                          App Setup
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}
                    {Permission?.includes(IDS.Permission.App_Setup.List) ||
                    Permission?.includes(IDS.Permission.App_Setup.Edit) ? (
                      <Link to="/cabappsetup" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/cabappsetup") ? "active" : ""
                          }`}
                        >
                          Cab Setup
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}
                    {Permission?.includes(IDS.Permission.App_Setup.List) ||
                    Permission?.includes(IDS.Permission.App_Setup.Edit) ? (
                      <Link to="/transportappsetup" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/transportappsetup") ? "active" : ""
                          }`}
                        >
                          Transport Setup
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              <></>
            )}
            {Permission?.includes(IDS.Permission.Contact.List) ||
            Permission?.includes(IDS.Permission.Enquiry.List) ? (
              <Accordion.Item eventKey="12">
                <Accordion.Header>Form</Accordion.Header>
                <Accordion.Body>
                  <div className="acc_inner_menu">
                    {Permission?.includes(IDS.Permission.Contact.List) ? (
                      <Link to="/contactus" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/contactus") ? "active" : ""
                          }`}
                        >
                          Contact Us
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Enquiry.List) ? (
                      <Link to="/enquiry" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/enquiry") ? "active" : ""
                          }`}
                        >
                          Mobile Contact Us
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              <></>
            )}
            {Permission?.includes(IDS.Permission.Users.List) ||
            Permission?.includes(IDS.Permission.Roles.List) ? (
              <Accordion.Item eventKey="23">
                <Accordion.Header>User Management</Accordion.Header>
                <Accordion.Body>
                  <div className="acc_inner_menu">
                    {Permission?.includes(IDS.Permission.Users.List) ? (
                      <Link to="/users" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/users") ? "active" : ""
                          }`}
                        >
                          Users
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Roles.List) ? (
                      <Link to="/roles" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/roles") ? "active" : ""
                          }`}
                        >
                          Roles
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              <></>
            )}
            {Permission?.includes(IDS.Permission.Customer.List) ||
            Permission?.includes(IDS.Permission.Driver.List) ? (
              <Accordion.Item eventKey="13">
                <Accordion.Header>Customer Management</Accordion.Header>
                <Accordion.Body>
                  <div className="acc_inner_menu">
                    {Permission?.includes(IDS.Permission.Customer.List) ? (
                      <Link to="/customer" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/customer") ? "active" : ""
                          }`}
                        >
                          Customer
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Driver.List) ||
                    Permission?.includes(IDS.Permission.Driver.Edit) ? (
                      <Link to="/driver" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/driver") ? "active" : ""
                          }`}
                        >
                          Driver
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              <></>
            )}
            {Permission?.includes(IDS.Permission.SOS.List) ? (
              <Accordion.Item eventKey="19">
                <Link to="/sos-request" onClick={closeSidebar}>
                  <Accordion.Header>SOS Requests</Accordion.Header>
                </Link>
              </Accordion.Item>
            ) : (
              <></>
            )}
            {Permission?.includes(IDS.Permission.Transport_Booking.List) ? (
              <Accordion.Item eventKey="14">
                <Accordion.Header>Transport Booking</Accordion.Header>
                <Accordion.Body>
                  <div className="acc_inner_menu">
                    {Permission?.includes(
                      IDS.Permission.Transport_Booking.List,
                    ) ? (
                      <Link to="/booking" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/booking") ? "active" : ""
                          }`}
                        >
                          Booking
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              <></>
            )}
            {Permission?.includes(IDS.Permission.Customer.List) ? (
              <Accordion.Item eventKey="18">
                <Accordion.Header>Cab Booking</Accordion.Header>
                <Accordion.Body>
                  <div className="acc_inner_menu">
                    {Permission?.includes(IDS.Permission.Customer.List) ? (
                      <Link to="/cab-booking" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/cab-booking") ? "active" : ""
                          }`}
                        >
                          Booking
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              <></>
            )}
            {Permission?.includes(IDS.Permission.Customer.List) ? (
              <Accordion.Item eventKey="24">
                <Accordion.Header>Share Bookings</Accordion.Header>
                <Accordion.Body>
                  <div className="acc_inner_menu">
                    {Permission?.includes(IDS.Permission.Customer.List) ? (
                      <Link to="/share-booking" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/share-booking") ? "active" : ""
                          }`}
                        >
                          Bookings
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              <></>
            )}
            {Permission?.includes(IDS.Permission.Customer.List) ? (
              <Accordion.Item eventKey="15">
                <Accordion.Header>Wallet Management</Accordion.Header>
                <Accordion.Body>
                  <div className="acc_inner_menu">
                    {Permission?.includes(IDS.Permission.Customer.List) ? (
                      <Link to="/withdraw-request" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/withdraw-request") ? "active" : ""
                          }`}
                        >
                          Withdraw Request
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}{" "}
                    {Permission?.includes(IDS.Permission.Customer.List) ? (
                      <Link to="/wallet-history" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/wallet-history") ? "active" : ""
                          }`}
                        >
                          Wallet History
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}
                    {Permission?.includes(IDS.Permission.Customer.List) ? (
                      <Link to="/wallet-payments" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/wallet-payments") ? "active" : ""
                          }`}
                        >
                          Wallet Payments
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              <></>
            )}
          </Accordion>
        </div>
      </section>
    </>
  );
};

export default Sidebar;
